function importAll(r) {
  r.keys().forEach(r);
}
import "../../../public/vendor/jquery/dist/jquery.js"
import "../../../public/vendor_modified/video.js/video.dev.js"
import "global/underscore.js"
import "../../../public/vendor/backbone/backbone.js"
import "../../../public/vendor_modified/backbone-deep-model/distribution/deep-model.js"
import "../../../public/vendor_modified/backbone.paginator/dist/backbone.paginator.js"
import "../../../public/vendor/marionette/lib/backbone.marionette.js"
import "../../../public/vendor_modified/iframeresizer/src/iframeResizer.contentWindow.js"
import "../../../public/vendor/cocktail/Cocktail.js"
import "../../../public/javascripts/routes.js"
import "../../../public/vendor_modified/sly/dist/sly.js"
import "../../../public/vendor/jquery.easing/js/jquery.easing.js"
importAll(require.context('../../../public/javascripts/base/config/', true, /\.js$/));
import "../../../public/javascripts/backbone/photos_app_v2.js"
import "../../../public/javascripts/backbone/lib/concerns/views/photoview_helpers.js"
importAll(require.context('../../../public/javascripts/base/backbone/lib/concerns/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/base/backbone/lib/entities/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/base/backbone/lib/controllers/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/base/backbone/lib/utilities/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/backbone/lib/utilities/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/backbone/lib/behaviors/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/backbone/lib/concerns/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/base/backbone/lib/views/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/base/backbone/lib/components/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/backbone/apps/slideshow/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/base/backbone/entities/', true, /\.js$/));
import "../../../public/javascripts/base/backbone/entities/abstract/config.js"
import "../../../public/javascripts/base/backbone/entities/abstract/display_options.js"
import "../../../public/javascripts/base/backbone/entities/abstract/recipe.js"
importAll(require.context('../../../public/javascripts/base/backbone/lib/components/loading/templates/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/backbone/apps/common/templates/v2/', true, /\.js$/));
importAll(require.context('../../../public/javascripts/backbone/apps/slideshow/', true, /\.js$/));
